export * from 'b2b-apps/core/common/utils/empty/empty';
